import Vue from "vue";

Vue.filter("itemNameVariation", function(item)
{
    if (item.hasOwnProperty("variationProperties"))
    {
        let returnval = item.texts.name1;

        for (let i = 0; i < item.variationProperties.length; i++)
        {
            if(item.variationProperties[i].hasOwnProperty("property"))
            {
                if(item.variationProperties[i].property.id === 106)
                {
                    returnval = item.variationProperties[i].values.value
                }
            }
            else
            {
                if (item.variationProperties[i].id===3)
                {
                    for (let i2 =0; i2 < item.variationProperties[i].properties.length; i2++ )
                    {
                        if (item.variationProperties[i].properties[i2].id === 106)
                        {
                            returnval = item.variationProperties[i].properties[i2].values.value;
                        }
                    }
                }
            }

        }
        return returnval;
    }
    else
    {
        return item.texts.name1;
    }
});
